// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import NotificationType from "./notification-type.js"

const modelClassData = {
  "attributes": {
    "audit_action": {
      "column": {
        "default": null,
        "name": "audit_action",
        "null": false,
        "type": "string"
      },
      "name": "audit_action",
      "selected_by_default": null,
      "translated": null
    },
    "auditable_type": {
      "column": {
        "default": null,
        "name": "auditable_type",
        "null": true,
        "type": "string"
      },
      "name": "auditable_type",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "notification_type_id": {
      "column": {
        "default": null,
        "name": "notification_type_id",
        "null": false,
        "type": null
      },
      "name": "notification_type_id",
      "selected_by_default": null,
      "translated": null
    },
    "target_user_liquid": {
      "column": {
        "default": null,
        "name": "target_user_liquid",
        "null": true,
        "type": "text"
      },
      "name": "target_user_liquid",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "NotificationTypeAuditTrigger",
  "collectionKey": "notification_type_audit_triggers",
  "collectionName": "notification_type_audit_triggers",
  "i18nKey": "notification_type_audit_trigger",
  "camelizedLower": "notificationTypeAuditTrigger",
  "name": "NotificationTypeAuditTrigger",
  "nameDasherized": "notification-type-audit-trigger",
  "pluralName": "notification_type_audit_triggers",
  "ransackable_associations": [
    {
      "className": "NotificationTypeAuditTrigger::Audit",
      "collectionName": "notification_type_audit_trigger_audits",
      "foreignKey": "notification_type_audit_trigger_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "NotificationTypeAuditTriggerAudit",
      "through": null
    },
    {
      "className": "ContactPoint",
      "collectionName": "contact_points",
      "foreignKey": "notification_type_audit_trigger_id",
      "name": "contact_points",
      "macro": "has_many",
      "resource_name": "ContactPoint",
      "through": null
    },
    {
      "className": "NotificationTypeAuditTrigger::Audit",
      "collectionName": "notification_type_audit_trigger_audits",
      "foreignKey": "notification_type_audit_trigger_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "NotificationTypeAuditTriggerAudit",
      "through": null
    },
    {
      "className": "NotificationType",
      "collectionName": "notification_types",
      "foreignKey": "notification_type_id",
      "name": "notification_type",
      "macro": "belongs_to",
      "resource_name": "NotificationType",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "audit_action",
      "column": {
        "default": null,
        "name": "audit_action",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "auditable_type",
      "column": {
        "default": null,
        "name": "auditable_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "notification_type_id",
      "column": {
        "default": null,
        "name": "notification_type_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "target_user_liquid",
      "column": {
        "default": null,
        "name": "target_user_liquid",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "NotificationType",
      "collectionName": "notification_types",
      "foreignKey": "notification_type_id",
      "name": "notification_type",
      "macro": "belongs_to",
      "resource_name": "NotificationType",
      "through": null
    }
  ],
  "paramKey": "notification_type_audit_trigger",
  "primaryKey": "id"
}

/** Frontend model for NotificationTypeAuditTrigger. */
export default class NotificationTypeAuditTrigger extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  auditAction() {
    return this.readAttributeUnderscore("audit_action")
  }

  /** @returns {boolean} */
  hasAuditAction() {
    const value = this.auditAction()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  auditableType() {
    return this.readAttributeUnderscore("auditable_type")
  }

  /** @returns {boolean} */
  hasAuditableType() {
    const value = this.auditableType()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  notificationTypeId() {
    return this.readAttributeUnderscore("notification_type_id")
  }

  /** @returns {boolean} */
  hasNotificationTypeId() {
    const value = this.notificationTypeId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  targetUserLiquid() {
    return this.readAttributeUnderscore("target_user_liquid")
  }

  /** @returns {boolean} */
  hasTargetUserLiquid() {
    const value = this.targetUserLiquid()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./notification-type.js").default | null} */
  notificationType() {
    return this._readBelongsToReflection({modelClass: NotificationType, reflectionName: "notification_type"})
  }

  /** @returns {Promise<import("./notification-type.js").default | null>} */
  loadNotificationType() {
    if (!("notificationTypeId" in this)) throw new Error("Foreign key method wasn't defined: notificationTypeId")

    const id = this.notificationTypeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "notification_type",
        model: this,
        modelClass: NotificationType
      },
      {ransack}
    )
  }
}
